import * as commonActionTypes from "../../shared/commonActionTypes";

export const setAction = (actionId, actionDescription, projectId, screenId) => {
  return {
    type: commonActionTypes.SET_ACTION,
    actionId: actionId,
    actionDescription: actionDescription,
    projectId: projectId,
    screenId: screenId
  };
};
